import { action } from 'typesafe-actions';
import { PaymentActionTypes, CreateCheckoutSessionPayload } from 'types';

export const createCheckoutSessionStart = (
  payload: CreateCheckoutSessionPayload
) => action(PaymentActionTypes.CREATE_CHECKOUT_SESSION_START, payload);

export const createCheckoutSessionSuccess = (payload: {
  clientSecret: string;
}) => action(PaymentActionTypes.CREATE_CHECKOUT_SESSION_SUCCESS, payload);

export const createCheckoutSessionFailure = (payload: string) =>
  action(PaymentActionTypes.CREATE_CHECKOUT_SESSION_FAILURE, payload);

export const getPaymentTypePriceStart = (paymentType: string) =>
  action(PaymentActionTypes.GET_PAYMENT_TYPE_PRICE_START, paymentType);
export const getPaymentTypePriceSuccess = (payload: {
  unitAmount: number;
  includeTax: boolean;
}) => action(PaymentActionTypes.GET_PAYMENT_TYPE_PRICE_SUCCESS, payload);
export const getPaymentTypePriceFailure = (payload: string) =>
  action(PaymentActionTypes.GET_PAYMENT_TYPE_PRICE_FAILURE, payload);

export const checkCheckoutSessionStatusStart = (sessionId: string) =>
  action(PaymentActionTypes.CHECK_CHECKOUT_SESSION_STATUS_START, sessionId);
export const checkCheckoutSessionStatusSuccess = (payload: {
  status: 'COMPLETED' | 'FAILED';
  paymentIntentId: string;
}) => action(PaymentActionTypes.CHECK_CHECKOUT_SESSION_STATUS_SUCCESS, payload);
export const checkCheckoutSessionStatusFailure = (payload: string) =>
  action(PaymentActionTypes.CHECK_CHECKOUT_SESSION_STATUS_FAILURE, payload);

export const confirmPostPaymentStart = (
  postPaymentId: number,
  purchaseOrderNumber?: string
) =>
  action(PaymentActionTypes.CONFIRM_POST_PAYMENT_START, {
    postPaymentId,
    purchaseOrderNumber
  });
export const confirmPostPaymentSuccess = () =>
  action(PaymentActionTypes.CONFIRM_POST_PAYMENT_SUCCESS);
export const confirmPostPaymentFailure = (payload: string) =>
  action(PaymentActionTypes.CONFIRM_POST_PAYMENT_FAILURE, payload);

export const clearPaymentState = () =>
  action(PaymentActionTypes.CLEAR_PAYMENT_STATE);
